/* eslint-disable indent */
/* eslint-disable quotes */
import React, { useState, useEffect, Fragment } from "react";
import Papa from "papaparse";

import { useSelector, useDispatch } from "react-redux";

import Card from "../../component/card/Card";
import ErrorRender from "../../component/request/ErrorRender";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import P from "../../component/smallComponents/P";
import ResponseRender from "../../component/request/ResponseRender";
import SelectInput from "../../component/input/SelectInput";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import Strong from "../../component/smallComponents/Strong";
import TextInput from "../../component/input/TextInput";
import {
  getBrowserDetails,
  toastHelper
} from "../../constant/helper/helper";
import Button from "../../component/button/Button";

import holiday_list_sample from "../../images/holiday.xlsx";
import { holidayActions } from "../../redux/actions";
import Starter from "../../component/Starter";
import { getAllZones } from "../../redux/actions/hrActions";
import isEmpty from "../../validation/isEmpty";
import HolidayTable from "./HolidayTable";

const AddHoliday = () => {
  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const [errors, setErrors] = useState("");
  const [CsvData, setCsvData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [zone, setZone] = useState("");
  const [response, setResponse] = useState("");
  const [csvFile, setCsvFile] = useState(null);

  const { allZones } = useSelector((state) => state.hr);

  const { holidayResponse, holidayError, holidayLoading } =
    useSelector((state) => state.holiday);

  useEffect(() => {
    if (!isEmpty(allZones)) {
      setZoneData(allZones);
    } else {
      setZoneData([]);
    }
  }, [allZones]);

  useEffect(() => {
    dispatch(getAllZones(loginType));
  }, []);

  useEffect(() => {
    setErrors(holidayError);
  }, [holidayError]);

  useEffect(() => {
    setResponse(holidayResponse);
  }, [holidayResponse]);

  // handle file upload
  const convertingCsvIntoJson = (csvFile) => {
    const csvRequiredFiled = ["Date", "Occasion", "Day"];

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: "greedy", // drop blank lines safely
      transformHeader: (h) => (h || "").trim(), // trim header keys
      transform: (v) => (typeof v === "string" ? v.trim() : v), // trim every cell
      complete: ({ data, errors }) => {
        try {
          // Optionally log parse errors from Papa
          if (errors && errors.length) {
            console.warn("Papa parse warnings/errors:", errors);
          }

          // Filter out rows that are entirely empty (all values blank after trim)
          const cleanedRows = data.filter((row) =>
            Object.values(row).some(
              (val) => String(val ?? "").trim() !== ""
            )
          );

          const jsonData = cleanedRows.map((row, index) => {
            // Validate required fields after trimming
            csvRequiredFiled.forEach((requiredField) => {
              const val = row[requiredField];
              if (val === undefined || String(val).trim() === "") {
                throw new Error(
                  `Missing or empty value for required field "${requiredField}" in row ${
                    index + 1
                  }`
                );
              }
            });

            return row;
          });

          console.log(jsonData);
          setCsvData(jsonData);
        } catch (error) {
          return toastHelper("error", error.message);
        }
      }
    });
  };

  const renderExcel = (
    <div className="row mt-3">
      <HolidayTable data={CsvData} />
    </div>
  );

  useEffect(() => {
    dispatch(holidayActions.setHolidayLoading(false));
    dispatch(holidayActions.clearHolidayErrors());
    dispatch(holidayActions.clearHolidayResult());
    return () => {
      setCsvFile(null);
      return () => {
        setCsvFile(null);
        dispatch(holidayActions.setHolidayLoading(false));
        dispatch(holidayActions.clearHolidayErrors());
        dispatch(holidayActions.clearHolidayResult());
      };
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const browserDetail = await getBrowserDetails();
    const os = browserDetail.os.name;
    const browser = browserDetail.browser.name;

    const userCsvToJsonData = {
      CsvData,
      ipAddress: localStorage?.publicIpAdd,
      zoneId: zone,
      workerId: localStorage.workerId,
      deviceDetails: os + "-" + browser,
      latitude: localStorage.latitude,
      longitude: localStorage.longitude
    };
    console.log(csvFile);
    // console.log(userCsvToJsonData);
    dispatch(holidayActions.setHolidayLoading(true));
    dispatch(holidayActions.clearHolidayErrors());
    dispatch(holidayActions.clearHolidayResult());
    dispatch(
      holidayActions.addHolidayList(userCsvToJsonData, loginType)
    );
  };

  const topInput = (
    <form onSubmit={onSubmit}>
      <div className="row mb-2">
        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <SelectInput
            required={true}
            textWhite={false}
            isLabeled={false}
            label="Select Zone"
            name="zone"
            value={zone}
            onChange={(e) => setZone(e.target.value)}
          >
            <option value="">Select Zone</option>
            {zoneData.map((zoneValue, index) => (
              <option value={zoneValue?._id} key={index}>
                {zoneValue?.zoneName}
              </option>
            ))}
          </SelectInput>
        </div>

        <div className="col-md-3 mt-3 col-xl-3 col-lg-3">
          <TextInput
            type="file"
            file={true}
            required={true}
            textWhite={false}
            htmlFor="csvFile"
            accept=".csv"
            onChange={(e) => {
              const csvFile = e.target.files[0];
              convertingCsvIntoJson(csvFile);
              setCsvFile(csvFile);
            }}
            label="Add CSV File to Add Holiday List"
          />
        </div>
        <div className="form-group text-center col-sm-3 mt-5 col-xl-3 col-l-3">
          {holidayLoading ? (
            <SpinnerButton />
          ) : (
            <Button
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn text-white btn-block btn-dark"
            />
          )}
        </div>
      </div>
    </form>
  );

  return (
    <Starter
      topBarTitle="Add Holiday List"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Rules Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Rules</a>
          </li>
          <li className="breadcrumb-item active">Add Holiday List</li>
        </Fragment>
      }
    >
      <div className="row">
        <div className="col-lg-12">
          <Card>
            <div className="row">
              <div className="col-lg-12">
                <Strong
                  title="All inputs are compulsory*"
                  className="text-danger float-right"
                />
                <HeaderTag
                  type="h4"
                  title="Add Holiday CSV List"
                  isClassName={false}
                />
                <P title="Fill the form below to Holiday List" />
                <HeaderTag
                  type="h4"
                  title="[ SYSTEM ONLY ACCEPT CSV FILE ]"
                  className="text-danger"
                  isClassName={true}
                />
              </div>
            </div>
            {topInput}
            {errors && <ErrorRender errors={errors} />}
            {response && <ResponseRender response={response} />}
          </Card>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-3">
          <button>
            <a href={holiday_list_sample} download>
              Download Sample Excel File To Holiday
            </a>
          </button>
        </div>
        <div className="col-lg-9">
          <Card>{renderExcel}</Card>
        </div>
      </div>
    </Starter>
  );
};

export default AddHoliday;
